export default __webpack_public_path__ + "static/404-ae5a41452285262f5db90071f567e40c.png";